import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45redirect_45global from "/app/client/middleware/route-redirect.global.js";
import secondary_45navigation_45global from "/app/client/middleware/secondary-navigation.global.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  route_45redirect_45global,
  secondary_45navigation_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "authenticated-client": () => import("/app/client/middleware/authenticated.client.js")
}